module.exports = __webpack_public_path__ + "img/icon9.2cc2be31.png";